
import { defineComponent } from 'vue';
import Logo from './Logo.vue';
import LoginButton from './LoginButton.vue';

export default defineComponent({
  name: 'TopBlock',
  components: { Logo, LoginButton },
  props: {
    white: Boolean,
    hide_logo: Boolean,
    hide_enter_button: Boolean,
    title: String,
    close: Boolean,
  },
});
